import type { FaireProductEntity } from "../../entity_types/product";

export const p_nupgjxmujv: FaireProductEntity = {
  token: "p_nupgjxmujv",
  type: "product",
  name: "Thank You Hug Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/65da43d5a8d29696d6da6511faa9c02ed7df9b23ee426ae8c3a4df7bf9e197cc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f10a4aff98f5211f8a850f3f8a4db2462c89332e92c19eded37f70ac208d09e3.png",
    "https://cdn.faire.com/fastly/39b8eb70194bf73d565d47b794205517bd1b13546177e9f5d20430f19e790db7.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:05.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
